import Breadcrumbs from '../../common/Breadcrumbs';
import {
  Container,
  Flex,
  TabList,
  TabPanels,
  TabPanel,
  Tabs,
  Tab,
  Divider,
  Text,
  useColorModeValue,
  Link,
} from '@chakra-ui/react';
import { MeContext } from '../../context/MeContext';
import { useContext, useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import useOrganizationStatus from '../../hooks/useOrganisationStatus';
import { useGetMeQuery } from '../../store/redux/api/accountApi';
import EmptyDefaultSvgAnimated from '../../theme/illustrations-animated/EmptyDefaultSvgAnimated';
import EmptyDefaultDarkSvgAnimated from '../../theme/illustrations-animated/EmptyDefaultDarkSvgAnimated';
import PassesBatchNavigationSwitchField from '../../components/client/batches/PassesBatchNavigationSwitchField';
import BatchesUpdateList from '../../components/client/batches/BatchesUpdateList';
import BatchesCreateList from '../../components/client/batches/BatchesCreateList';
import { BatchListContextProvider } from '../../store/client/BatchListContext';
import FeatureFlagGuard from '../../common/FeatureFlagGuard';
import PageHeadingWithTrialProgress from '../../components/client/dashboard/PageHeadingWithTrialProgress';

const BatchesPage = () => {
  const modeBorderColor = useColorModeValue('primaryBackground', 'primaryDark');
  const meCtx = useContext(MeContext);
  const { filterEntity } = meCtx.state;
  const [searchParams, setSearchParams] = useSearchParams();
  const modeSvgIcon = useColorModeValue(
    <EmptyDefaultSvgAnimated />,
    <EmptyDefaultDarkSvgAnimated />
  );
  const { shouldRender, components } = useOrganizationStatus(modeSvgIcon);
  const [tabIndex, setTabIndex] = useState(() =>
    searchParams.get('tab') === 'create' ? 1 : 0
  );
  const { data: me } = useGetMeQuery();

  const handleTabChange = (index) => {
    setTabIndex(index);
    if (index === 1) {
      setSearchParams({ tab: 'create' });
      return;
    }
    setSearchParams({});
  };

  useEffect(() => {
    if (me && !me?.batch_pass_updates_enabled && tabIndex === 0) {
      setTabIndex(1);
      setSearchParams({ tab: 'create' });
    }
  }, [me, tabIndex, setSearchParams]);

  const breadcrumbLinks = [
    {
      linkName: 'Home',
      linkUrl: '/',
    },
    {
      linkName: 'passes',
      linkUrl: '/passes',
    },
    {
      linkName: 'batches',
      linkUrl: '/passes/batches',
    },
  ];

  return (
    <>
      <Container pb={6}>
        <Breadcrumbs breadcrumbLinks={breadcrumbLinks} />
        <PageHeadingWithTrialProgress title="Passes" />
        <Text fontSize="18px" mb="20px">
          <Link
            textDecoration="underline"
            textUnderlineOffset="5px"
            href="https://docs.passentry.com/documentation/bulk-operations/batch-pass-creation/guide"
            target="_blank"
          >
            Upload a CSV
          </Link>{' '}
          to create or update multiple passes at once.
        </Text>
        <PassesBatchNavigationSwitchField />
        <BatchListContextProvider>
          <Tabs index={tabIndex} onChange={handleTabChange}>
            <TabList>
              <FeatureFlagGuard
                flagKey="batch_pass_updates_enabled"
                redirectOnDisabled={false}
              >
                <Tab fontSize="20px">Update</Tab>
              </FeatureFlagGuard>
              <Tab fontSize="20px">Create</Tab>
            </TabList>
            <TabPanels>
              <FeatureFlagGuard
                flagKey="batch_pass_updates_enabled"
                redirectOnDisabled={false}
              >
                <TabPanel p={0}>
                  <BatchesUpdateList
                    filterEntity={filterEntity}
                    isActive={tabIndex === 0}
                  />
                </TabPanel>
              </FeatureFlagGuard>
              <TabPanel p={0}>
                <BatchesCreateList
                  filterEntity={filterEntity}
                  isActive={tabIndex === 1}
                />
              </TabPanel>
            </TabPanels>
          </Tabs>
        </BatchListContextProvider>
      </Container>
    </>
  );
};

export default BatchesPage;
